// @ts-check
import SwitcherSetting from 'Components/Common/Settings/SwitcherSetting';
import { observer } from 'mobx-react';
import React from "react";
import UserSettingsStore from 'Stores/userSettingsStore';

/**
 * @param {{
 * id?: string,
 * className?: string,
 * title: string,
 * helperText?: string,
 * settingName?: string
 * getSettingName?: () => string
 * }} props 
 * @returns {React.JSX.Element}
 */
const UserSwitcherSetting = (props) => {
    let settingName =
        (props.getSettingName
            ? props.getSettingName()
            : props.settingName) ?? '';

    return (
        <SwitcherSetting
            id={props.id}
            className={props.className}
            title={props.title}
            helperText={props.helperText}
            disabled={UserSettingsStore.settings[settingName]?.disabled === true}
            value={UserSettingsStore.settings[settingName]?.value === true}
            onChanged={(value) => UserSettingsStore.SetSetting(settingName, value)} />
    )
}

export default observer(UserSwitcherSetting);